export const APPLE_TOUCH_ICON_PATH = '/apple-touch-icon.png';

export const buildAppleTouchIconHref = (version) => {
  const trimmed = version && String(version).trim();
  if (!trimmed) {
    return APPLE_TOUCH_ICON_PATH;
  }

  return `${APPLE_TOUCH_ICON_PATH}?v=${encodeURIComponent(trimmed)}`;
};

export const getPwaIconVersionFromManifest = (manifest) => {
  const icons = manifest?.icons;
  if (!Array.isArray(icons)) {
    return '';
  }

  for (const icon of icons) {
    const src = String(icon?.src || '');
    const match = src.match(/[?&]v=([^&]+)/);
    if (!match?.[1]) {
      continue;
    }

    try {
      return decodeURIComponent(match[1]);
    } catch {
      return match[1];
    }
  }

  return '';
};

export const applyAppleTouchIcon = (version) => {
  if (typeof document === 'undefined') {
    return;
  }

  let link = document.head.querySelector('link[rel="apple-touch-icon"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'apple-touch-icon');
    document.head.appendChild(link);
  }

  link.setAttribute('sizes', '180x180');
  link.setAttribute('href', buildAppleTouchIconHref(version));
};
